module.exports = __webpack_public_path__ + "img/banner-loading-4.085d389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/project/loader/banner-loading-4.jpg
// module id = ZVic
// module chunks = 9